import typeToReducer from 'type-to-reducer';
import { combineReducers } from 'redux';
import { loadingStateReducer } from '../utils';

import {
  CLEAR_GRAPH_TEMPLATE,
  CREATE_GRAPH_TEMPLATE,
  DELETE_GRAPH_TEMPLATE_BY_ID,
  FAVORITE_GRAPH_TEMPLATE,
  GET_GRAPH_TEMPLATE_BY_ID,
  LOAD_GRAPHS_TEMPLATES,
  LOAD_SENSOR_AVERAGE,
  LOAD_SENSOR_HISTORY,
  LOAD_STATUS_HISTORY,
  UPDATE_GRAPH_TEMPLATE
} from './constants';

const initialState = {
  newTemplate: null,
  error: null,
  favoritesRevision: 0,
  templates: []
};

export default combineReducers({
  loadingState: loadingStateReducer(
    LOAD_GRAPHS_TEMPLATES,
    FAVORITE_GRAPH_TEMPLATE,
    GET_GRAPH_TEMPLATE_BY_ID,
    DELETE_GRAPH_TEMPLATE_BY_ID,
    CREATE_GRAPH_TEMPLATE
  ),
  data: typeToReducer(
    {
      [LOAD_GRAPHS_TEMPLATES]: {
        SUCCESS: (state, { payload }) => ({
          ...state,
          templates: payload
        })
      },
      [FAVORITE_GRAPH_TEMPLATE]: {
        SUCCESS: state => ({
          ...state,
          favoritesRevision: state.favoritesRevision + 1
        })
      },
      [GET_GRAPH_TEMPLATE_BY_ID]: {
        SUCCESS: (state, { payload }) => ({
          ...state,
          currentTemplate: payload
        })
      },
      [DELETE_GRAPH_TEMPLATE_BY_ID]: {
        SUCCESS: (state, { payload }) => ({
          ...state,
          deleteSuccess: payload
        })
      },
      [CREATE_GRAPH_TEMPLATE]: {
        SUCCESS: (state, { payload }) => ({
          ...state,
          newTemplate: payload
        }),
        FAILURE: (state, { payload }) => ({
          ...state,
          error: payload
        })
      },
      [CLEAR_GRAPH_TEMPLATE]: state => ({
        ...state,
        currentTemplate: null
      })
    },
    initialState
  ),
  loadSensorHistoryStatus: loadingStateReducer(LOAD_SENSOR_HISTORY),
  sensorHistoryResponse: typeToReducer(
    {
      [LOAD_SENSOR_HISTORY]: {
        SUCCESS: (_data, { payload }) => payload
      }
    },
    []
  ),
  loadStatusHistoryStatus: loadingStateReducer(LOAD_STATUS_HISTORY),
  statusHistoryResponse: typeToReducer(
    {
      [LOAD_STATUS_HISTORY]: {
        SUCCESS: (_data, { payload }) => payload
      }
    },
    []
  ),
  loadSensorAverageStatus: loadingStateReducer(LOAD_SENSOR_AVERAGE),
  sensorAverageResponse: typeToReducer(
    {
      [LOAD_SENSOR_AVERAGE]: {
        SUCCESS: (_data, { payload }) => payload
      }
    },
    []
  ),
  updateTemplateStatus: loadingStateReducer(UPDATE_GRAPH_TEMPLATE)
});
